import React from 'react';
import { connect } from 'react-redux';
import { i18n, tokens, Modal, Text } from '@simplybenefits/sb-ui-library';
import { useLottie } from "lottie-react";
import claimProcessingAnimation from "../../../../assets/claim-processing-animation.json";

/**
 * This is the check mark animation component which uses the lottie-react library
 */
const ClaimProcessingAnimation = () => {
    const options = {
        animationData: claimProcessingAnimation,
        loop: true
    };

    const { View } = useLottie(options);

    return (
        <div
            style={{
                width: "100%",
                maxWidth: "325px",
                margin: "0 auto"
            }}
        >
            { View }
        </div>
    );
};

/**
 * @returns {JSX.Element}
 * @constructor
 */
const ClaimProcessingModal = () => (
    <Modal open={true}>
        <ClaimProcessingAnimation />

        <Text
            align={"center"}
            display="block"
            large
            bold
        >
            { i18n.t(tokens.labels.claims.processingClaimTitle) }
        </Text>

        <Text
            align={"center"}
            display="block"
            margin="10px 0 0 0"
            medium
        >
            { i18n.t(tokens.labels.claims.processingClaimMessage) }
        </Text>
    </Modal>
);

export default connect()(ClaimProcessingModal);